import { render, staticRenderFns } from "./TabBlink.vue?vue&type=template&id=54d43972"
import script from "./TabBlink.vue?vue&type=script&lang=js"
export * from "./TabBlink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports